<div class="card-header">
  <app-breadcrumb currentPage="bewind aanmaken"></app-breadcrumb>
</div>

<div class="card-body">
  <form [formGroup]="form" class="form">

    <h2>1. Persoonsgegevens rechthebbende</h2>

    <!-- firstNameInitials -->
    <div [ngClass]="{ 'input-error': submitted && f.firstNameInitials.errors }">
      <label for="firstNameInitials" class="form-label">{{'name.first_name_initials' | translate}}</label>
      <input formControlName="firstNameInitials" id="firstNameInitials" type="text">
      <div class="errors">
        <div *ngIf="f.firstNameInitials.errors?.required"> {{'name.first_name_initials.required' | translate}}</div>
        <div *ngIf="f.firstNameInitials.errors?.maxlength">{{'name.first_name_initials.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- firstName -->
    <div [ngClass]="{ 'input-error': submitted && f.firstName.errors }">
      <label for="firstName" class="form-label">{{'name.first_name' | translate}}</label>
      <input formControlName="firstName" id="firstName" type="text">
      <div class="errors">
        <div *ngIf="f.firstName.errors?.required"> {{'name.first_name.required' | translate}}</div>
        <div *ngIf="f.firstName.errors?.maxlength">{{'name.first_name.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- insertion -->
    <div [ngClass]="{ 'input-error': submitted && f.insertion.errors }">
      <label for="insertion" class="form-label">{{'name.insertion' | translate}}</label>
      <input formControlName="insertion" id="insertion" type="text">
      <div class="errors">
        <div *ngIf="f.insertion.errors?.maxlength">{{'name.insertion.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- lastName -->
    <div [ngClass]="{ 'input-error': submitted && f.lastName.errors }">
      <label for="lastName" class="form-label">{{'name.last_name' | translate}}</label>
      <input formControlName="lastName" id="lastName" type="text">
      <div class="errors">
        <div *ngIf="f.lastName.errors?.required">{{'name.last_name.required' | translate}}</div>
        <div *ngIf="f.lastName.errors?.maxlength">{{'name.last_name.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- birthdate -->
    <div [ngClass]="{ 'input-error': submitted && f.dateOfBirth.errors }">
      <label class="form-label" for="dateOfBirth">{{'client.birthdate' | translate}}</label>
      <input formControlName="dateOfBirth" id="dateOfBirth" placeholder="dd-mm-jjjj" type="text">
      <div class="errors">
        <div *ngIf="f.dateOfBirth.errors?.required">{{'client.birthdate.required' | translate}}</div>
        <div *ngIf="!f.dateOfBirth.errors?.required && f.dateOfBirth.errors?.validDate">{{'client.birthdate.invalid' | translate}}</div>
      </div>
    </div>

    <div class="spacer-large"></div>
    <h2>2. adresgegevens rechthebbende</h2>
    <!-- street -->
    <div [ngClass]="{ 'input-error': submitted && f.street.errors }">
      <label for="street" class="form-label">{{'address.street' | translate}}</label>
      <input formControlName="street" id="street" type="text">
      <div class="errors">
        <div *ngIf="f.street.errors?.required">{{'address.street.required' | translate}}</div>
        <div *ngIf="f.street.errors?.maxlength">{{'address.street.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- houseNumber -->
    <div [ngClass]="{ 'input-error': submitted && f.houseNumber.errors }">
      <label for="houseNumber" class="form-label">{{'address.house_number' | translate}}</label>
      <input formControlName="houseNumber" id="houseNumber" type="text">
      <div class="errors">
        <div *ngIf="f.houseNumber.errors?.required">{{'address.house_number.required' | translate}}</div>
        <div *ngIf="f.houseNumber.errors?.maxlength">{{'address.house_number.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- houseNumberSuffix -->
    <div [ngClass]="{ 'input-error': submitted && f.houseNumberSuffix.errors }">
      <label for="houseNumberSuffix" class="form-label">{{'address.house_number_suffix' | translate}}</label>
      <input formControlName="houseNumberSuffix" id="houseNumberSuffix" type="text">
      <div class="errors">
        <div *ngIf="f.houseNumberSuffix.errors?.required">{{'address.house_number_suffix.required' | translate}}</div>
        <div *ngIf="f.houseNumberSuffix.errors?.maxlength">{{'address.house_number_suffix.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- zipCode -->
    <div [ngClass]="{ 'input-error': submitted && f.zipCode.errors }">
      <label for="zipCode" class="form-label">{{'address.zip_code' | translate}}</label>
      <input formControlName="zipCode" id="zipCode" type="text">
      <div class="errors">
        <div *ngIf="f.zipCode.errors?.required">{{'address.zip_code.required' | translate}}</div>
        <div *ngIf="f.zipCode.errors?.maxlength">{{'address.zip_code.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- city -->
    <div [ngClass]="{ 'input-error': submitted && f.city.errors }">
      <label for="city" class="form-label">{{'address.city' | translate}}</label>
      <input formControlName="city" id="city" type="text">
      <div class="errors">
        <div *ngIf="f.city.errors?.required">{{'address.city.required' | translate}}</div>
        <div *ngIf="f.city.errors?.maxlength">{{'address.city.maxLength' | translate}}</div>
      </div>
    </div>

    <div class="spacer-large"></div>
    <h2>3. bewindgegevens</h2>

    <!-- Court -->
    <div [ngClass]="{ 'input-error': submitted && f.courtId.errors }">
      <label class="form-label">{{'client.court' | translate}}</label>
      <app-select [options]="courts" formControlName="courtId" labelIndex="name" valueIndex="id"></app-select>
      <div class="errors">
        <div *ngIf="f.courtId.errors?.required">{{'client.court.required' | translate}}.</div>
      </div>
    </div>

    <!-- CaseType -->
    <div [ngClass]="{ 'input-error': submitted && f.caseType.errors }">
      <label class="form-label">{{'client.case_type' | translate}}</label>
      <div>
        <label for="BM"><input formControlName="caseType" id="BM" type="radio" value="BM">BM (Bewind meerderjarig)</label>
      </div>
      <div>
        <label for="CB"><input formControlName="caseType" id="CB" type="radio" value="CB">CB (Curatele bewind)</label>
      </div>
      <div class="errors">
        <div *ngIf="f.caseType.errors?.required">{{'client.case_type.required' | translate}}</div>
      </div>
    </div><br>
    voor informatie over het dossiernummer bezoek:
    <a href="https://ccbr.rechtspraak.nl/#!/zoeken" class="link" target="_blank">ccbr.rechtspraak.nl</a>

    <!-- CaseNumber -->
    <div [ngClass]="{ 'input-error': submitted && f.caseNumber.errors }">
      <label class="form-label" for="caseNumber">{{'client.case_number' | translate}}</label>
      <input formControlName="caseNumber" id="caseNumber" type="text">
      <div class="errors">
        <div *ngIf="f.caseNumber.errors?.required">{{'client.case_number.required' | translate}}</div>
        <div *ngIf="f.caseNumber.errors?.pattern">{{'client.case_number.number' | translate}}</div>
        <div *ngIf="f.caseNumber.errors?.maxLength">{{'client.case_number.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- StartDate -->
    <div [ngClass]="{ 'input-error': submitted && f.startDate.errors }">
      <label class="form-label" for="startDate">{{'client.start_date' | translate}}</label>
      <input (change)="updateYears()" formControlName="startDate" id="startDate"
             placeholder="dd-mm-jjjj" type="text">
      <div class="errors">
        <div *ngIf="f.startDate.errors?.required">{{'client.start_date.required' | translate}}</div>
        <div *ngIf="!f.startDate.errors?.required && f.startDate.errors?.validDate">
          {{'client.start_date.invalid' | translate}}
        </div>
        <div *ngIf="!f.startDate.errors?.required && !f.startDate.errors?.validDate && f.startDate.errors?.validPassedDate">
          {{'client.start_date.not_in_past' | translate}}
        </div>
      </div>
    </div>

    <label class="form-label unselectable" for="bbToBeMade">
      <input formControlName="bbToBeMade" id="bbToBeMade" type="checkbox">
      <span class="pl12">
        dient er nog een <strong>boedelbeschrijving</strong> te worden gemaakt?
      </span>
    </label>

    <label [ngClass]="olderThan(f.startDate.value, 1) ? '' : 'hidden'" class="form-label unselectable"
           style="width: 1000px;"
           for="catchingUp">
      <input formControlName="catchingUp" id="catchingUp" type="checkbox">
      <span class="pl12" *ngIf="olderThan(f.startDate.value, 2)">
        dient er nog rekening en verantwoording te worden afgelegd over {{ getPreviousYear() }} of eerder?
      </span>
      <span class="pl12" *ngIf="!olderThan(f.startDate.value, 2)">
        dient er nog rekening en verantwoording te worden afgelegd over {{ getPreviousYear() }}?
      </span>
    </label>

    <div [ngClass]="olderThan(f.startDate.value, 2) && f.catchingUp.value ? '' : 'hidden'">
      <label class="form-label" for="catchingUpYear">vanaf welk jaar?</label>
      <app-select [options]="years"
                  id="catchingUpYear"
                  formControlName="catchingUpYear"
                  labelIndex="value"></app-select>
    </div>

    <label [ngClass]="olderThan(f.startDate.value, 5) ? '' : 'hidden'" class="form-label unselectable"
           for="previousVjeToBeMade">
      <input formControlName="previousVjeToBeMade" id="previousVjeToBeMade" type="checkbox">
      <span
        class="pl12">dient de <strong>vijfjaarlijkse evaluatie van {{getPreviousVjeDeadline(f.startDate.value)}}</strong> nog te worden gemaakt?</span>
    </label>

    <div class="spacer-large"></div>
    <h2>4. Inzage door rechthebbende</h2>

    <label class="form-label unselectable" for="showClientEmailField">
      <input formControlName="showClientEmailField" id="showClientEmailField" type="checkbox">
      <span class="pl12">e-mailadres rechthebbende invoeren</span>
    </label>

    <div [ngClass]="{ 'input-error': submitted && f.email.errors }">
      <div [ngClass]="{ 'hidden' : !f.showClientEmailField.value }">
        <label class="form-label" for="clientEmail">e-mailadres van rechthebbende</label>
        <input formControlName="email" id="clientEmail" type="email">
        <div class="errors">
          <div *ngIf="f.email.errors?.required">{{'email_address.required' | translate}}</div>
          <div *ngIf="f.email.errors?.pattern">{{'email_address.invalid' | translate}}</div>
          <div *ngIf="f.email.errors?.maxlength">{{'email_address.maxLength' | translate}}</div>
        </div>
      </div>
    </div>

    <div class="spacer-large"></div>
    <h2>5. Tweede bewindvoerder</h2>
    <label class="form-label unselectable" for="addSecondUser">
      <input formControlName="addSecondUser" id="addSecondUser" type="checkbox">
      <span class="pl12">is er sprake van een tweede bewindvoerder?</span>
    </label>
    <div class="spacer-large"></div>
    <div class="btn arrow-left" routerLink="/">annuleer</div>
    <button class="btn check accent inverted ml14" (click)="submit(form.value)">opslaan</button>
  </form>
</div>
